//noinspection JSUnusedGlobalSymbols

/**
 * ESA Component: Payment Controller
 * -------------------------------------------------------------
 * @copyright (c) 2024 [Paul Höcker|PHMG](https://phmg.online). All rights reserved.
 * @license   GNU General Public License version 3 or later
 * @version   1.0.0, 2024-01-01 00:00
 */

import Controller from "@phmg/com_hive/src/js/exports/Controller.js"

class PaymentController extends Controller {
  static CID = 'payment'
  static NAME = 'Payment'

  CallHandler
  FormHandler

  initiate() {
    super.initiate();

    let key = this.context.key || 'default';
    let formId = `#adminForm`;

    //const FormHandlerClass = window.Hive.getFormHandler();
    this.FormHandler = window.Hive.getFormHandler(this, formId);

    let url = window.location.origin + '/index.php?option=com_esa&format=json';
    //const CallHandlerClass = window.Hive.getCallHandler();
    this.CallHandler = window.Hive.getCallHandler(this, url);

    let data = {};

    switch (key) {
      case 'initiate' :

        // Prevent form submission via enter key
        //document.addEventListener(`keypress`, (event) => {
        //	const form = event.target.closest(formId);
        //	if (form) {
        //		if (event.target.dataset.enterForSubmit) {
        //			if (event.key === `Enter`) {
        //				event.preventDefault();
        //
        //				// get the button for submit, check if it is disabled
        //				const formButton = form.querySelector(`button[data-task]`);
        //				if (formButton && !formButton.disabled) {
        //					formButton.click();
        //				}
        //			}
        //			return true;
        //		}
        //	}
        //})

        // Verhindere Form Submission
        this.FormHandler
          .preventSubmit(true);

        // Verhindere Form Submission
        this.FormHandler
          .addListener('keypress', 'input[type=text]', (event) => {
            if (event.key === `Enter`) {
              event.preventDefault();

              // get the button for submit, check if it is disabled
              const formButton = this.FormHandler.getForm().querySelector(`button[data-type="submit"]`);
              if (formButton && !formButton.disabled) {
                formButton.click();
              }
            }
            return true;
          });

        // Bei Auswahl eines Dokuments
        this.FormHandler.addListener('change', '#jform_document_id input[type=radio]',
          () => this.utils.addTimer(() => {
            let checked = document.getElementById('jform_document_id').querySelector('input:checked');
            let value = checked ? checked.value : '';
            this.FormHandler.toggleButton('[data-task="payment.initiate_document"]', (value.length > 0));
          }, 100, 'jform_document_id'));

        // Bei Eingabe eines Codes
        this.FormHandler.addListener(['keyup', 'change'], '#jform_element_code',
          ({ target }) => this.utils.addTimer(() => {
            let value = (target.value || '').toUpperCase();
            target.value = value;
            this.FormHandler.toggleButton('[data-task="payment.initiate_document"]', (value.length === 6));
          }, 100, 'jform_element_code'));

        // Bei Auswahl einer Zahlungsmethode
        this.FormHandler.addListener('change', '#jform_payment_method input[type=radio]',
          () => this.utils.addTimer(() => {
            let checked = document.getElementById('jform_payment_method').querySelector('input:checked');
            let value = checked ? checked.value : '';
            this.FormHandler.toggleButton('[data-task="payment.initiate_method"]', (value.length > 0));
          }, 100, 'jform_payment_method'));

        // Bei Klick auf einen der Buttons
        this.FormHandler.addListener('click', 'button[data-task]',
          (event) => {
            event.preventDefault();
            const element = event.target;
            let request = element.dataset.task;
            let formData;

            if (request === 'payment.reset') {
              formData = new FormData();
            } else if (this.FormHandler.getValidator() && !document.formvalidator.isValid(this.FormHandler._formElement)) {
              return;
            } else {
              formData = this.FormHandler.getData();
              formData.delete('task');
              formData.delete('option');
            }
            formData.append('request', request);

            this.FormHandler.lockForm();
            this.CallHandler.postRequest('api.post',
              formData,
              (success, response) => {
                this.FormHandler.freeFrom(success);
                if (success) {
                  if (typeof response.html === 'string') {
                    this.utils.replaceElement('[data-content="payment.initiate"]', response.html,
                      element => {
                        // Reset the form validator
                        this.FormHandler.getValidator().attachToForm(element.closest('form'));
                      })
                  } else if (typeof response.task === 'string') {
                    this.FormHandler.preventSubmit(false);
                    this.FormHandler.submitform(response.task);
                  }
                }
              })
          });

        // Trigger change event to show buttons right at the start
        [].slice.call(document.querySelectorAll(`input[type=radio]:checked`))
          .forEach(input => input.dispatchEvent(new Event('change', { bubbles : true })));

        break;

      case 'checkout' :

        this.FormHandler
          .preventSubmit(true)

        this.FormHandler
          .addListener('click', 'button[data-task]',
            (event) => {
              event.preventDefault();
              const task = event.target.dataset.task;
              this.FormHandler.preventSubmit(false);
              this.FormHandler.submitform(task);
            });

        break;

      case 'complete' :
        break;
    }
  }
}

export default PaymentController
